import { Component, Input, OnInit } from '@angular/core'
import { InlineEditCellDirective } from '../inline-edit-cell'

@Component({
  selector: 'jml-lib-float-cell',
  templateUrl: './float-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class FloatCellComponent extends InlineEditCellDirective implements OnInit {
  @Input() decimals

  ngOnInit(): void {}

  abortCellEdit(event: any): void {
    super.abortCellEdit(event)
  }

  onKeyupEnter(valid: any) {
    if (valid) {
      this.isEdited = false
      this.completeCellEdit.emit({ data: this.rowData, field: this.fieldName })
    }
  }

  getRepresentation(): string {
    const value = this.rowData[this.fieldName]
    if (value === undefined || value === null) {
      return ''
    }
    if (typeof value === 'number' || value instanceof Number) {
      return value.toLocaleString('de', {
        minimumFractionDigits: 0,
        maximumFractionDigits: this.decimals === null ? 20 : this.decimals
      })
    }
    return value
  }

  triggerEdit() {
    this.originalContent = this.rowData[this.fieldName]
    const value = this.rowData[this.fieldName]
    if (typeof value === 'string' || value instanceof String) {
      if (value.indexOf('.') === -1 && value.indexOf(',') > -1) {
        this.rowData[this.fieldName] = parseFloat(value.replace(',', '.'))
      }
    }
    this.isEdited = true
  }
}
